export const SearchIconBuilderComponent = {
  name: '_SearchIcon_',
  inputs: [],
} as const;

export default SearchIconBuilderComponent;
